import * as constants from '../constants/organizationActionTypes';

export function getOrganization(organizationID) {
  return (dispatch) => {
    dispatch({
      type: constants.ORGANIZATION_GET,
      organizationID: organizationID,
    });
  };
}

export function getOrganizationFeatureFlags(organizationID) {
  return (dispatch) => {
    dispatch({
      type: constants.ORGANIZATION_GET_FEATURE_FLAGS,
      organizationID: organizationID,
    });
  };
}

export function editOrganization(id, payload, notification?) {
  return (dispatch) => {
    dispatch({
      type: constants.ORGANIZATION_EDIT,
      id: id,
      payload: payload,
      notification,
    });
  };
}

export function uploadAvatar(file) {
  return (dispatch) => {
    dispatch({
      type: constants.ORGANIZATION_UPLOAD_AVATAR,
      file: file,
    });
  };
}

export function updateAvatar(file, organization) {
  return (dispatch) => {
    dispatch({
      type: constants.ORGANIZATION_GET_PRESIGNED,
      file: file,
      organization: organization,
    });
  };
}

export function organizationLoaded(organization) {
  return (dispatch) => {
    dispatch({
      type: constants.ORGANIZATION_LOADED,
      organization: organization,
    });
  };
}

export function changeDefaultNumber(defaultNumber) {
  return (dispatch) => {
    dispatch({
      type: constants.ORGANIZATION_CHANGE_DEFAULT_NUMBER,
      defaultNumber,
    });
  };
}
